import { createAsyncThunk } from '@reduxjs/toolkit';
import { AICoachGoalsApi } from 'api/AICoachGoalsApi';

import { ErrorResponse } from './ErrorResponse';

export const createApplyScoreGoalThunk = (api: AICoachGoalsApi) =>
  createAsyncThunk('yourGoal/applyScoreGoal', async (applicationId: string, thunkApi) => {
    try {
      return await api.applyScoreGoal(applicationId);
    } catch (error: unknown) {
      return thunkApi.rejectWithValue((error as ErrorResponse).response.data);
    }
  });
